import { z } from "zod";
import { UserSchema } from "./User";
import { BranchToUserSchema } from "@/branches/models/BranchToUser";

const BaseHistorySchema = z.object({
	createdAt: z.string(),
	operation: z.enum(["INSERT", "UPDATE", "DELETE"]),
	branchName: z.string().nullable(),
	changerName: z.string(),
	totalCount: z.number().int(),
});

export const UserHistoryEntrySchema = z.discriminatedUnion("tableName", [
	BaseHistorySchema.extend({
		tableName: z.literal("users"),
		oldRow: UserSchema.partial().nullable(),
		newRow: UserSchema.partial().nullable(),
	}),

	BaseHistorySchema.extend({
		tableName: z.literal("_branchesTousers"),
		oldRow: BranchToUserSchema.partial().nullable(),
		newRow: BranchToUserSchema.partial().nullable(),
	}),
]);

export type UserHistoryEntryType = z.infer<typeof UserHistoryEntrySchema>;
